var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"acomodarHora"},[(_vm.debug === 'true' || _vm.debug === true)?_c('span',[_vm._v(_vm._s(_vm.version))]):_vm._e(),_c('hr',{staticStyle:{"height":"5px","background-color":"#17A2B8","margin":"0px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }